import type {
  FieldType,
  FormField
} from '@elfsight/widget-form-builder/widget';

const mapFieldNames = (type: FieldType) =>
  type === 'phone' ? 'phone number' : type;

export const prepareSubmitFormFields = (fields: FormField[]): FormField[] => {
  return fields.map((field) => ({
    ...field,
    name: mapFieldNames(field.type)
  }));
};
